import {BaseSelect2Factory} from "./BaseSelect2Factory";

class FaceSelect2Factory extends BaseSelect2Factory{
    ajaxUrl() {
        return '/select2/face';
    }
}

export const faceSelect2Factory = new FaceSelect2Factory();